import { render, staticRenderFns } from "./MyQuestionDet.vue?vue&type=template&id=20507abc&scoped=true"
import script from "./MyQuestionDet.vue?vue&type=script&lang=js"
export * from "./MyQuestionDet.vue?vue&type=script&lang=js"
import style0 from "./MyQuestionDet.vue?vue&type=style&index=0&id=20507abc&prod&lang=css"
import style1 from "./MyQuestionDet.vue?vue&type=style&index=1&id=20507abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20507abc",
  null
  
)

export default component.exports